<template>
  <o-table
    :items="neyosTrackers"
    :loading="loading"
    defaultSort="number"
    :draggable="false"
    paginated
    :per-page="100"
  >
    <b-table-column v-slot="{ index }" cell-class="has-text-grey">
      {{ index + 1 }}
    </b-table-column>
    <b-table-column v-slot="{ row }" field="number" label="Numéro" sortable>
      <b-tooltip :label="`Serial : ${row.serial}`" type="is-light" position="is-right">
        <span class="has-text-weight-medium">{{ row.number }}</span>
      </b-tooltip>
    </b-table-column>
    <b-table-column v-slot="{ row }" field="availability" label="Status" sortable>
      <b-tag :type="tags[row.availability].type">
        {{ tags[row.availability].label }}
      </b-tag>
    </b-table-column>
    <b-table-column v-slot="{ row }" field="wear" label="Usure" sortable>
      <b-tooltip
        :label="wears.find((wear) => wear.value === row.wear).label"
        type="is-light"
        position="is-right"
      >
        <b-icon :icon="wearIcons[row.wear].icon" size="is-small" :type="wearIcons[row.wear].type" />
      </b-tooltip>
    </b-table-column>
    <b-table-column v-slot="{ row }" field="owner" label="Propriétaire" sortable>
      {{ capitalize(row.owner) }}
    </b-table-column>

    <b-table-column v-slot="{ row }" field="locatedAt" label="Dernier point" sortable>
      {{ formatDate(row.locatedAt) }}
    </b-table-column>
    <b-table-column v-slot="{ row }" field="batteryPercentage" label="Batterie" sortable>
      <o-battery-level-indicator
        v-if="row.batteryPercentage !== undefined"
        :battery-percentage="row.batteryPercentage"
      />
      <span v-else>–</span>
    </b-table-column>

    <b-table-column v-slot="{ row }" label="">
      <div class="buttons are-small is-right">
        <b-button
          type="is-primary"
          tag="router-link"
          :to="{ name: 'neyosTracker.edit', params: { id: row.id } }"
        >
          <b-icon icon="edit" />
        </b-button>
      </div>
    </b-table-column>
  </o-table>
</template>

<script>
import { capitalize } from '@helpers/capitalize'
import OTable from '@components/Table.vue'
import { format } from 'date-fns'
import { TAGS } from '@constants/tracker/tag'
import { WEARS, WEAR_ICONS } from '@constants/tracker/wear'
import OBatteryLevelIndicator from '@components/BatteryLevelIndicator.vue'

export default {
  name: 'ListNeyosTrackersTable',

  components: {
    OTable,
    OBatteryLevelIndicator,
  },

  props: {
    neyosTrackers: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  created() {
    this.tags = TAGS
    this.wears = WEARS
    this.wearIcons = WEAR_ICONS
  },

  methods: {
    capitalize(value) {
      return capitalize(value)
    },
    formatDate(date) {
      return !date ? 'Aucune date' : format(date, 'dd/MM/yyyy')
    },
  },
}
</script>
